import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import Maleficent from '../img/Profolio/Malecifent-Glass.jpg';
import Mayor from '../img/Profolio/Mayor-Glass.jpg';
import MoonSkull from '../img/Profolio/CalaveraDeLaLuna.jpg';
import MickeyBallons from '../img/Profolio/Mickey-Balloons.jpg';
import Courage from '../img/Profolio/CourageDisney.jpg';
import Cauldron from '../img/Profolio/cauldron.jpg';
import Frida from '../img/Profolio/Frida.jpg';
import MoonozSign from '../img/Profolio/Moonoz-Sign.jpg';
import Navy from '../img/Profolio/Disenoz-Sec-Navy.jpg';


function Profolio() {
    return (
        <>
            <Container className="page-Title" fluid>
                <h1>*Art Profolio*</h1>
            </Container>
            <Container className="No-Left-Right flex-Sec space-Bottom" fluid>
                <Image src={MoonozSign} className="space-Bottom-Top" fluid />
                <Row>
                    <Col md>
                        <Image src={Maleficent} className="art-Img-width left-Start flex-Sec" alt="Maleficent sleeping beauty" />
                    </Col>
                    <Col md>
                        <Image src={Mayor} className="art-Img-width right-Start flex-Sec" alt="Mayor " />
                    </Col>
                </Row>
                <Image src={MickeyBallons} className="space-Bottom-Top" fluid />
                <Row>
                    <Col md>
                        <Image src={MoonSkull} className="art-Img-width left-Start flex-Sec" alt="Moon skull Rose" />
                    </Col>
                    <Col md>
                        <Image src={Frida} className="art-Img-width right-Start flex-Sec" alt="the Mayor Nightmare before Christmas" />
                    </Col>
                </Row>
                <Image src={Navy} className="space-Bottom-Top" fluid />
                <Row>
                    <Col md>
                        <Image src={Cauldron} className="art-Img-width left-Start flex-Sec" alt="witches cauldron" />
                    </Col>
                    <Col md>
                        <Image src={Courage} className="art-Img-width right-Start flex-Sec" alt="Courage the cowardly dog Disney mickey ears" />
                    </Col>
                </Row>
            </Container>

        </>
    );
}

export default Profolio;